'use strict';

angular.module('sellers')
.directive('backBtn', ['$window', function ($window) {
  return {
    restrict : "E"
    ,replace: true
    ,scope: false
    ,template : '<a href class="back-button"><i class="fa fa-chevron-left fa-lg"></i></a>'
    ,link : function (scope, element, attrs) {
        element.on('click', function() {
             $window.history.back();
         });
    }
  }
}]);
